module.exports = __webpack_public_path__ + "parilux.d3d5705eccf1f5eae018962946a2cf86.svg";